// extracted by mini-css-extract-plugin
module.exports = {"banner-qr-box":"e","bannerQrBox":"e","qr-img-box":"f","qrImgBox":"f","qr-img-text":"g","qrImgText":"g"};